import Main from "./components/main/main";
import { store } from "./store/store";
import { Provider } from "react-redux";
import { LangProvider } from "./i18n/LangContext";
import "./App.scss";

const App = () => {
  return (
    <Provider store={store}>
      <LangProvider>
        <Main />
      </LangProvider>
    </Provider>
  );
};

export default App;
